import { makeStyles } from "@material-ui/core";

const LoginStyles = makeStyles((theme) => ({
    mainContainer: {
        width: '100%',
        height: '100vh',
        float: "left",
        backgroundColor: theme.palette.disabled.main
    },
    logoView: {
        paddingBottom: 24
    },
    mainContainerinr: {
        width: '100%',
        maxWidth: 450,
        [theme.breakpoints.between(0, 420)]: {
            maxWidth: "96%",
            "& .extcustomIcon": {
                width: "100%"
            }
        }
    }, loginTemplate: {
        width: '100%',
        margin: '0 auto'
    },
    loginTemplateinr: {
        width: '100%',
        float: "left"
    },
    loginTemplateFields: {
        background: theme.palette.common.white,
        borderRadius: 8,
        padding: '24px 16px',
        boxShadow: theme.shadows[3],
        marginBottom: 25,
        minHeight: 248,
        width: 'calc(100% - 32px)',
        float: 'left'
    },
    loginSinglerow: {
        textAlign: "center",
        marginBottom: 4
    },
    root: {
        flexGrow: 1,
        paddingBottom: 8,
        paddingTop: 10
    },
    container: {
        textAlign: "center"
    },
    errorMessage: {
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.body2.fontSize,
        color: theme.palette.error.main,
        lineHeight: 1.4,
        float: "left",
        textAlign: 'center',
        width: '100%',
        padding: '8px 0 0 0'
    },
    buttonProgress: {

    }
}));

export default LoginStyles